/**
 * Generates a random token string.
 *
 * @example
 * // Returns a random token string
 * const token = randomToken();
 * console.log(token);
 *
 * @returns {string} A random token string.
 */
export default function randomToken(){
 return Math.random().toString(36).substring(2);
}